<template>
  <InterfaceCard
      icon="mdi-cog"
      title="Настройка группы"
  >
    <template slot="tabs">
      <v-tabs
          v-model="currentTab"
          :show-arrows="$vuetify.breakpoint.mobile"
      >
        <v-tabs-slider color="pink"></v-tabs-slider>

        <v-tab
            icons-and-text
            v-for="tab in tabs"
            :key="tab.id"
        >
          <v-icon left>{{tab.icon}}</v-icon>
          {{ tab.title }}
        </v-tab>
      </v-tabs>
    </template>

    <SourceSettingsWidget v-if="currentTab === tabs[0].id"></SourceSettingsWidget>

  </InterfaceCard>
</template>

<script>
import InterfaceCard from '@/components/InterfaceCard'
import SourceSettingsWidget from '@/components/SourceSettingsWidget'
const tabs = [{
  id: 0,
  title: 'Виджет',
  icon: 'mdi-widgets'
}]

export default {
  name: 'SourceSettings',
  components: {InterfaceCard, SourceSettingsWidget},
  data () {
    return {
      currentTab: tabs[0].id,
      tabs: tabs
    }
  }
}
</script>

<style scoped>

</style>